/* SnusUK theme scripts
 * 1. Age gate (date-of-birth check, remembered in localStorage)
 * 2. Live price on the product page "Add to basket" button
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
   * 1. Age gate
   * ------------------------------------------------------------- */
  var STORAGE_KEY = 'snusuk_age_verified_until';

  function initAgeGate() {
    var gate = document.getElementById('SnusAgeGate');
    if (!gate) return;
    var root = document.documentElement;
    if (!root.classList.contains('snus-age-pending')) return;

    var form = gate.querySelector('form');
    var day = gate.querySelector('[name="day"]');
    var month = gate.querySelector('[name="month"]');
    var year = gate.querySelector('[name="year"]');
    var error = gate.querySelector('.snus-age-gate__error');
    var minAge = parseInt(gate.dataset.minAge, 10) || 18;
    var rememberDays = parseInt(gate.dataset.rememberDays, 10) || 30;

    // Keep keyboard and screen-reader users inside the gate.
    var outside = Array.prototype.filter.call(document.body.children, function (el) {
      return el !== gate && el.tagName !== 'SCRIPT';
    });
    outside.forEach(function (el) { el.setAttribute('inert', ''); });
    gate.removeAttribute('hidden');
    setTimeout(function () { day.focus(); }, 50);

    // Move to the next box once one is full.
    [[day, month, 2], [month, year, 2]].forEach(function (pair) {
      pair[0].addEventListener('input', function () {
        pair[0].value = pair[0].value.replace(/\D/g, '');
        if (pair[0].value.length >= pair[2]) pair[1].focus();
      });
    });
    year.addEventListener('input', function () { year.value = year.value.replace(/\D/g, ''); });

    function showError(message) {
      error.textContent = message;
      error.hidden = false;
      [day, month, year].forEach(function (i) { i.setAttribute('aria-invalid', 'true'); });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var d = parseInt(day.value, 10);
      var m = parseInt(month.value, 10);
      var y = parseInt(year.value, 10);
      var now = new Date();
      var dob = new Date(y, m - 1, d);

      var valid =
        year.value.length === 4 &&
        dob.getFullYear() === y && dob.getMonth() === m - 1 && dob.getDate() === d &&
        y > 1900 && dob <= now;

      if (!valid) {
        showError(error.dataset.invalid);
        day.focus();
        return;
      }

      var age = now.getFullYear() - y;
      if (now.getMonth() < m - 1 || (now.getMonth() === m - 1 && now.getDate() < d)) age--;

      if (age < minAge) {
        showError(error.dataset.underage);
        return;
      }

      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now() + rememberDays * 86400000));
      } catch (e) { /* storage blocked: gate simply shows again next visit */ }

      root.classList.remove('snus-age-pending');
      gate.setAttribute('hidden', '');
      outside.forEach(function (el) { el.removeAttribute('inert'); });
      var main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
  }

  /* ---------------------------------------------------------------
   * 2. "Add to basket · £X" price on the product form
   * ------------------------------------------------------------- */
  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function updateAtcPrice(sectionId, unitCents) {
    document.querySelectorAll('[data-snus-atc-price="' + sectionId + '"]').forEach(function (el) {
      if (typeof unitCents === 'number') el.dataset.unitPrice = unitCents;
      var unit = parseInt(el.dataset.unitPrice, 10);
      if (isNaN(unit)) { el.hidden = true; return; }
      var qtyInput = document.getElementById('Quantity-' + sectionId);
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      el.querySelector('[data-amount]').textContent = formatMoney(unit * qty);
      var button = el.closest('button');
      el.hidden = !!(button && button.disabled);
    });
  }

  function initAtcPrice() {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || !data.sectionId) return;
        // Wait a tick so Dawn has toggled the button's disabled state first.
        setTimeout(function () {
          updateAtcPrice(data.sectionId, data.variant ? data.variant.price : undefined);
        }, 0);
      });
    }

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.id || input.id.indexOf('Quantity-') !== 0) return;
      updateAtcPrice(input.id.replace('Quantity-', ''));
    });

    // Quantity +/- buttons fire "change" on the input in Dawn; this also covers typing.
    document.addEventListener('input', function (event) {
      var input = event.target;
      if (!input || !input.id || input.id.indexOf('Quantity-') !== 0) return;
      updateAtcPrice(input.id.replace('Quantity-', ''));
    });
  }

  function init() {
    initAgeGate();
    initAtcPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
